import {
  SDG_REVENUE_ADJUSTED_QUESTION_IDS,
  SDG_REVENUE_ADJUSTED_SDG_ONE_QUESTION_IDS,
  SDG_REVENUE_QUESTION_IDS,
  SDG_REVENUE_SDG_ONE_QUESTION_IDS,
  SDI_REVENUE_QUESTION_IDS,
  SDI_REVENUE_SDG_ONE_QUESTION_IDS,
} from '@netpurpose/types'

// Per-SDG question IDs run sequentially without gaps from the SDG 1 entry, so
// each hardcoded base expands to the ids for all 17 SDGs.
const getSdgQuestionIds = (sdgOneQuestionId: number): number[] =>
  Array.from({ length: 17 }, (_, index) => sdgOneQuestionId + index)

// Built once rather than per call, as this is used from inside filter
// predicates that run for every row.
const validRevenueQuestionIds = new Set<number>([
  270, // Revenue
  272195, // Revenue Segments
  272226, // Geographic revenue segments
  ...Object.values(SDG_REVENUE_QUESTION_IDS),
  ...Object.values(SDG_REVENUE_ADJUSTED_QUESTION_IDS),
  ...Object.values(SDG_REVENUE_SDG_ONE_QUESTION_IDS).flatMap(getSdgQuestionIds),
  ...Object.values(SDG_REVENUE_ADJUSTED_SDG_ONE_QUESTION_IDS).flatMap(getSdgQuestionIds),
  ...Object.values(SDI_REVENUE_QUESTION_IDS),
  ...Object.values(SDI_REVENUE_SDG_ONE_QUESTION_IDS).flatMap(getSdgQuestionIds),
])

export const isRevenueQuestionId = (questionId: number): boolean =>
  validRevenueQuestionIds.has(questionId)
